import React from "react";
import { Table, Header, Checkbox, Button } from "semantic-ui-react";
import { getDatePart } from "@common/components/helpers/datetime";
import { UKDateFormat } from "@common/constants/datetime";

const SelectMergeCustomers = ({ selectedToMerge, toggleSelected, isSelected, clear, clearButtonEnabled, mergeButtonEnabled, goToConfirm, disabled }) => {
    return (
        <Table compact definition className="merge-table-container">
            <Table.Header fullWidth>
                <Table.Row>
                    <Table.HeaderCell colSpan='2'>
                    <Header as='h4' >{disabled ? 'Selected' : 'Select'} Merge Customers</Header>
                    </Table.HeaderCell>
                    <Table.HeaderCell />
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {
                selectedToMerge.map((c) => (
                    <Table.Row key={c.id} className="w-100">
                    <Table.Cell collapsing>
                        <Checkbox onChange={() => toggleSelected(c, false)} checked={isSelected(c)} disabled={disabled} />
                    </Table.Cell>
                    <Table.Cell>{`${c?.forename} ${c?.surname}, ${c?.site?.name}, Interactions: ${c?.customerStats?.interactionCount}, ${c?.ageRange?.name}, ${c?.ethnicity?.name}, ${c?.gender?.name}, ${getDatePart(c?.dateCreated, UKDateFormat)}, ID: ${c?.id}`}</Table.Cell>
                    </Table.Row>
                ))
                }
            </Table.Body>

            {!disabled && (
                <Table.Footer fullWidth size='mini'>
                    <Table.Row>                     
                        <Table.HeaderCell/>
                        <Table.HeaderCell textAlign='right' colSpan='2'>
                        <Button.Group size='mini'>
                            <Button color="red" onClick={clear} disabled={!clearButtonEnabled}>
                                Clear
                            </Button>
                            <Button
                                color="green"
                                disabled={!mergeButtonEnabled}
                                onClick={goToConfirm}
                            >
                                Merge
                            </Button>
                        </Button.Group>
                        </Table.HeaderCell>                   
                    </Table.Row>
                </Table.Footer>
            )}


        </Table>
    )
}

export default SelectMergeCustomers;